document.addEventListener('DOMContentLoaded', function() {
    function waitForFlickity(callback, attemptsLeft) {
      attemptsLeft = attemptsLeft === undefined ? 40 : attemptsLeft;
      if (typeof Flickity !== 'undefined') {
        callback();
        return;
      }
      if (attemptsLeft <= 0) {
        return;
      }
      setTimeout(function () {
        waitForFlickity(callback, attemptsLeft - 1);
      }, 50);
    }

    document.querySelectorAll('.carousel[data-featured-slider]').forEach(slider => {
      const featuredCollection = slider.closest('.featured-collection');
      let desktopColumns = parseInt(featuredCollection?.getAttribute('data-columns'), 10) || 1;

      function getGroupCells() {
        return window.innerWidth < 768 ? 1 : desktopColumns;
      }

      function setArrowsPosition() {
        const arrows = slider.querySelectorAll('.flickity-button');
        const image = slider.querySelector('[data-product-media-container]');
        if (!arrows.length || !image) return;
        arrows.forEach(arrow => {
          arrow.style.top = `${image.offsetHeight / 2}px`;
        });
      }

      function changeTabIndex(flkty) {
        flkty.slides.forEach((slide, index) => {
          slide.cells.forEach(cell => {
            cell.element.querySelectorAll('a, button').forEach(link => {
              link.setAttribute('tabindex', flkty.selectedIndex === index ? '0' : '-1');
            });
          });
        });
      }

      function createSlider(groupCells) {
        const flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          prevNextButtons: true,
          pageDots: true,
          draggable: true,
          wrapAround: false,
          groupCells: groupCells,
          on: {
            ready: () => {
              setArrowsPosition();
              setTimeout(() => changeTabIndex(flkty), 0);
            },
            change: () => changeTabIndex(flkty)
          }
        });
        return flkty;
      }

      waitForFlickity(function () {
        let flkty = createSlider(getGroupCells());

        // Re-init on resize when group changes
        window.addEventListener('resize', function() {
          const newGroup = getGroupCells();
          if (flkty.options?.groupCells !== newGroup) {
            flkty.destroy();
            flkty = createSlider(newGroup);
          }
        });
      });
    });
  });
